module.exports = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n\t<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.4777 17.4581V12.8459L6.86547 12.8459L6.86547 11.8012L11.4777 11.8012L11.4777 7.18901L12.5223 7.18901L12.5223 11.8012L17.1345 11.8012L17.1345 12.8459L12.5223 12.8459V17.4581H11.4777Z\" fill=\"#DC0000\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/add.svg
// module id = 427
// module chunks = 0